"use strict";import{Avatar as a}from"./src/Avatar.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-avatar",a);
//# sourceMappingURL=sp-avatar.js.map
